import {ROLE_SUPER_USER, ROLE_USER} from '../../../helpers'

export const videoLessonRoute = [
  {
    path: '',
    name: 'UserVideoLesson',
    component: () => import('../../../components/User/VideoLesson'),
    meta: {
      access: [ROLE_USER, ROLE_SUPER_USER]
    }
  },
  {
    path: ':id',
    name: 'ShowVideoLessons',
    component: () => import('../../../components/User/VideoLesson/show'),
    meta: {
      access: [ROLE_USER, ROLE_SUPER_USER]
    }
  },
  {
    path: 'watch/:id',
    name: 'ReWatchVideoLessons',
    component: () => import('../../../components/User/VideoLesson/watch'),
    meta: {
      access: [ROLE_USER, ROLE_SUPER_USER]
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/user/module/videoLesson.js